import { Wrapper } from '@american-autonomy/ag-ui';

import MultiSelectPanel from 'components/MultiSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { ENTITY_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Item, Props } from './types';

const DroneMultiSelectPanelField: FunctionComponent<Props> = ({
    className = '',
    onChange,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { droneItems, handleAsyncFilter, hasNextPage, isLoading, noItemsText, onNextPage } =
        useData();

    const handleToggle = (drone: Item) => {
        const isSelected = value.some(item => item.value === drone.value);

        if (isSelected) {
            onChange(value.filter(item => item.value !== drone.value));
        } else {
            onChange([...value, drone]);
        }
    };

    return (
        <Wrapper className={className} testId={testId}>
            <MultiSelectPanel
                entityType={ENTITY_TYPE}
                hasNextPage={hasNextPage}
                isLoading={isLoading}
                items={droneItems}
                itemsSelected={value}
                label={SEARCH}
                noItemsFoundText={noItemsText}
                onFilter={handleAsyncFilter}
                onNextPage={onNextPage}
                onToggle={handleToggle}
            />
        </Wrapper>
    );
};

export default DroneMultiSelectPanelField;
